<template>
    <v-container v-if="this.zamawiajacy" class="page">
      <table>
        <thead>
          <tr>
            <td>
              <div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
                <div class="left-cointainer">
                  <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
                </div>
                <div class="right-cointainer">
                  Tutore Poland Sp. z o.o.<br>
                  ul. Piotrkowska 157A, 90-440 Łódź<br>
                  NIP: 7272812193
                </div>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p align="center" style="margin-top:20px;">
                <strong>Annex to the Contract Number {{ numerUmowy }}</strong>
              </p>
              <p>
                Concluded between:
              </p>
              <p><strong>Principal:</strong></p>
              <p>
                <strong>Tutore Poland Sp. z o.o.</strong>, with its registered office in Łódź at ul. Piotrkowska 157A, 90-440 Łódź, entered in the Register of Entrepreneurs of the National Court Register kept by the District Court for Łódź-Śródmieście, XX Commercial Division of the National Court Register under KRS number 0000670834, NIP: 727-28-12-193, REGON: 366891567, represented by:
              </p>
              <p>
                <strong>{{ zamawiajacy }}</strong>,
              </p>
              <p>and</p>
            </br>
                <strong>Contractor:</strong>
                <br />
                Name: {{ imieNazwisko }}
                <br />
                PESEL: {{ pesel }}
                <br />
                Address: {{ zamieszkany }}
                <br />
                <br />
              <p align="center" style="margin-bottom: 0px;">
                <strong>§ 1</strong>
              </p>
              <p>The Principal and the Contractor hereby declare that on {{ dataAneks }}, they amend, by virtue of this annex, the binding contract number {{ numerUmowy }} concluded on {{ dataPodpisania }}.</p>
              <p align="center" style="margin-bottom: 0px;">
                <strong>§ 2</strong>
              </p>
              <p>The scope of the contract is {{ zmiana }}</p>
              <p align="center" style="margin-bottom: 0px;">
                <strong>§ 3</strong>
              </p>
              <p>All other terms of the contract remain unchanged.</p>
              <p align="center" style="margin-bottom: 0px;">
                <strong>§ 4</strong>
              </p>
              <p>This annex has been drawn up in two identical copies, one for each party.</p>
  
              <div class="cointainer" style="margin-top: 30px;">
                <div class="left-cointainer">
                  <span style="margin-left: 0%;">{{ zamawiajacy }}</span><br>
                  <span style="margin-left: 0%;">Principal</span>
                </div>
                <div class="right-cointainer">
                  {{ imieNazwisko }}<br>
                  <span style="margin-left: 0%;">Contractor</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </v-container>
  </template>
  
  <script>
  export default {
    name: 'AneksTutorePoland2024ENG',
    data () {
      return {
        zamawiajacy: '',
        imieNazwisko: '',
        pesel: '',
        zamieszkany: '',
        zmiana: '',
        dataAneks: '',
        numerUmowy: '',
        dataPodpisania: ''
      }
    },
    created () {
      Object.entries(this.$route.query).forEach(
        ([key, value]) => { this[key] = value }
      )
    },
    methods: {
    },
    mounted () {
      if (this.zamawiajacy) {
        this.$nextTick(() => {
          window.setTimeout(() => {
            const currentURL = window.location.href
            history.replaceState(history.state, '', '/')
            window.print()
            history.replaceState(history.state, '', currentURL)
          }, 300)
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .page {
    size: 210mm 297mm;
    background-size: 100% 100%;
    line-height: 1.4;
    text-align: justify;
    margin-top: 2px;
    padding-top: 0px;
  }
  table {
    border: 1px;
    border-collapse: collapse;
    table-layout: fixed;
  }
  th, td {
    border: 1px;
    border-collapse: collapse;
  }
  .cointainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .cointainer-left {
    width: 20%;
  }
  .cointainer-right {
    width: 20%;
  }
  thead {
    display: table-header-group;
  }
  .table-border {
    border: 1px solid black;
    border-collapse: collapse;
    padding: 5px;
  }
  .cell-in-first-table {
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: 10px;
    margin-right: 10px;
  }
  ul.dashed {
    list-style-type: "- ";
    margin: 0;
  }
  .underline {
    text-decoration: underline;
  }
  .pageNum {
    position: absolute;
    right: 0px;
    font-size: 14px;
  }
  #oswiadczenie {
    padding: 20px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/AneksTutorePoland2024ENG.vue